import { gql } from '@apollo/client';

export const GET_OUTPUT_MAPPER_CONFIG = gql`
    query OutputMapperConfig($key: String!, $ownerId: UUID!) {
        outputMapperConfig(key: $key, ownerId: $ownerId) {
            config
            isDefault
            isActive
            warnings
            schemaOutdated
            configuredFieldsOutOfSync
        }
    }
`;

export const UPDATE_OUTPUT_MAPPER_CONFIG = gql`
    mutation UpdateOutputMapperConfig(
        $key: String!
        $ownerId: UUID!
        $config: GenericScalar
        $refreshSchema: Boolean
        $syncConfiguredFields: Boolean
    ) {
        updateOutputMapperConfig(
            key: $key
            ownerId: $ownerId
            config: $config
            refreshSchema: $refreshSchema
            syncConfiguredFields: $syncConfiguredFields
        ) {
            success
            errors
            warnings
            validation {
                valid
                errors
            }
            config
        }
    }
`;

export const GET_OUTPUT_MAPPER_TEST_RECORDS = gql`
    query OutputMapperTestRecords($key: String!, $ownerId: UUID!, $limit: Int) {
        outputMapperTestRecords(key: $key, ownerId: $ownerId, limit: $limit) {
            id
            createdAt
            sender
            subject
            documentNumber
            channelId
            channelName
        }
    }
`;

export const GENERATE_TEMPLATE_FROM_XSD = gql`
    mutation GenerateTemplateFromXsd($xsdKey: String!, $xsdContent: String, $targets: [String]) {
        generateTemplateFromXsd(xsdKey: $xsdKey, xsdContent: $xsdContent, targets: $targets) {
            template
            success
            error
        }
    }
`;

export const GENERATE_TEMPLATE_WITH_AI = gql`
    mutation GenerateTemplateWithAi(
        $templateFormat: String!
        $instruction: String
        $example: String
        $currentTemplate: String
        $targets: [String]
        $inputTypes: GenericScalar
        $collectionSources: GenericScalar
    ) {
        generateTemplateWithAi(
            templateFormat: $templateFormat
            instruction: $instruction
            example: $example
            currentTemplate: $currentTemplate
            targets: $targets
            inputTypes: $inputTypes
            collectionSources: $collectionSources
        ) {
            template
            summary
            unmatched
            newTargetFields {
                target
                source
                type
            }
            success
            error
        }
    }
`;

export const TEST_OUTPUT_MAPPING = gql`
    mutation TestOutputMapping($recordId: UUID!, $key: String!, $config: GenericScalar!, $returnType: String) {
        testOutputMapping(recordId: $recordId, key: $key, config: $config, returnType: $returnType) {
            result {
                success
                error
                mappedOutput
                mappedOutputCsv
                mappedOutputXml
                mappedOutputTxt
                mappedOutputTemplate
                fileName
                inputData
                configName
                configVersion
                returnType
            }
        }
    }
`;
